import { render, staticRenderFns } from "./ItemAjustesNomina.vue?vue&type=template&id=2262bcb8&"
import script from "./ItemAjustesNomina.vue?vue&type=script&lang=js&"
export * from "./ItemAjustesNomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports